export default "__VITE_ASSET__BGyk7npx__"